<public-account-shell
  [heading]="'account.forgotPassword.title' | transloco"
  [subheading]="'account.forgotPassword.subtitle' | transloco"
>
  @if (submitted()) {
    <div class="forgot__result" role="status">
      <i class="fa-solid fa-envelope-circle-check forgot__icon" aria-hidden="true"></i>
      <p class="forgot__text">{{ 'account.forgotPassword.confirmation' | transloco }}</p>
      <a routerLink="/login" class="forgot__link">{{ 'account.forgotPassword.backToLogin' | transloco }}</a>
    </div>
  } @else {
    <form class="forgot__form" (ngSubmit)="onSubmit()">
      <div class="forgot__field">
        <label class="forgot__label" for="email">{{ 'account.forgotPassword.email' | transloco }}</label>
        <input
          id="email"
          name="email"
          type="email"
          class="forgot__input"
          [ngModel]="email()"
          (ngModelChange)="email.set($event)"
          autocomplete="email"
          required
        />
      </div>

      @if (errorKey()) {
        <p class="forgot__error" role="alert">
          @if (errorTitleKey()) {
            <strong>{{ errorTitleKey() | transloco }}</strong><br />
          }
          {{ errorKey() | transloco }}
        </p>
      }

      <button eBtn block color="primary" type="submit" [disabled]="!emailIsValid()" [loading]="isSubmitting()">
        {{ 'account.forgotPassword.submit' | transloco }}
      </button>

      <p class="forgot__footer">
        <a routerLink="/login" class="forgot__link">{{ 'account.forgotPassword.backToLogin' | transloco }}</a>
      </p>
    </form>
  }
</public-account-shell>
